import classNames from 'classnames';

export const composeCSSProperties = (properties: { [key: string]: string }) =>
    classNames(
        Object.entries(properties)
            .filter(([, value]) => value)
            .map(([key, val]) => `${key}: ${val};`)
    );
